import './OnboardingPages.scss';

import React, {useState} from 'react';
import {Alert, Button, Col, Container, Row, Spinner} from "react-bootstrap";
import HandicaddieLogo from "../../../icons/HandicaddieLogo";
import Form from "react-bootstrap/Form";
import {Formik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {FORGOT_PASSWORD_EMAIL, REGISTER_CREDENTIALS, REGISTER_EMAIL_CONFIRM} from "../../../services/PageUtils";
import {SessionService} from "../../../services/api/SessionService";
import {CredentialsService} from "../../../services/api/CredientialsService";
import ErrorText from "../../../components/ErrorText";
import {useDispatch} from "react-redux";
import {AppDispatch} from "../../../services/store/store";
import {handleEnteringRegisteringOrResetting} from "../../../services/store/reducers/session/slice";

interface Props {

}

const Login = ({}: Props) => {

    const navigate = useNavigate();
    const dispatch = useDispatch<AppDispatch>();

    const {createSession} = SessionService();
    const {resendConfirmation} = CredentialsService();

    const [loading, setLoading] = useState(false);
    const [errMsg, setErrMsg] = useState<string>();

    const schema = yup.object().shape({
        email: yup.string().email().required("Email address is required"),
        password: yup.string().required("Password is required"),
    });

    const submitForm = async (values: any) => {
        setLoading(true);
        setErrMsg(undefined)
        let resp = await createSession({
            email: values.email,
            password: values.password,
        });
        setLoading(false);
        if (resp.error) {
            setErrMsg(resp.error.message);
            if (resp.error.apiError?.code === 'E1001') {
                let resp = await resendConfirmation({
                    email: values.email,
                    password: values.password
                });
                if (resp.error) {
                    setErrMsg(resp.error.message);
                    return;
                }
                navigate(REGISTER_EMAIL_CONFIRM, {
                    state: {
                        email: values.email,
                        password: values.password,
                    }
                });
            }
        }
    };

    const goToForgotPassword = () => {
        dispatch(handleEnteringRegisteringOrResetting())
        navigate(FORGOT_PASSWORD_EMAIL);
    }


    const goToRegister = () => {
        dispatch(handleEnteringRegisteringOrResetting())
        navigate(REGISTER_CREDENTIALS);
    }

    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Container>
                <div className={"onboarding_logoContainer"}>
                    <HandicaddieLogo size={'lg'}/>
                </div>

                <div>
                    <span className={"heading"}>Login</span>
                </div>

                <div>
                    <Formik
                        validationSchema={schema}
                        onSubmit={submitForm}
                        initialValues={{
                            email: "",
                            password: "",
                        }}
                    >
                        {({
                              handleSubmit,
                              handleChange,
                              handleBlur,
                              values,
                              touched,
                              isValid,
                              errors,
                          }) => (
                            <Form
                                noValidate
                                onSubmit={handleSubmit}
                            >
                                <Row>
                                    <Col>
                                        <Form.Label column={'lg'}>Email</Form.Label>
                                        <Form.Group controlId="detailsForm.Email">
                                            <Form.Control
                                                required
                                                className="onboarding_input"
                                                type="email"
                                                name="email"
                                                placeholder="Email address"
                                                value={values.email}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                            />
                                            {touched.email && errors.email && (
                                                <Alert variant={"danger"}>
                                                    {errors.email}
                                                </Alert>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <Form.Label column={'lg'}>Password</Form.Label>
                                        <Form.Group controlId="detailsForm.Password">
                                            <Form.Control
                                                required
                                                className="onboarding_input"
                                                type="password"
                                                name="password"
                                                placeholder="Password"
                                                value={values.password}
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                            />
                                            {touched.password && errors.password && (
                                                <Alert variant={"danger"}>
                                                    {errors.password}
                                                </Alert>
                                            )}
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <div className={"login_forgotPasswordContainer"}>
                                    <span onClick={goToForgotPassword}>
                                        Forgot your password?
                                    </span>
                                </div>

                                {errMsg && <ErrorText>{errMsg}</ErrorText>}

                                {!loading && <Button
                                    type="submit"
                                    disabled={loading}
                                    className={"login_submitBtn"}
                                >
                                    LOGIN
                                </Button>}
                                {loading && <Button disabled={loading} onClick={() => {
                                }} className={"login_submitBtn"}>
                                    <Spinner animation={"border"}/>
                                </Button>}
                            </Form>
                        )}
                    </Formik>
                </div>
            </Container>

            <div className={"login_registerContainer"}>
                <div className={"login_line"}/>
                <span className={"login_registerTxt"}>Or, you can create a new account:</span>
                <Button variant={"secondary"} className={"login_registerBtn"} onClick={goToRegister}>
                    REGISTER
                </Button>
            </div>
        </div>
    )
}

export default Login;